// eslint-disable-next-line import/no-cycle
import { APIS, clients } from '@/core/clients';

const client = clients[APIS.SELF_SERVICE];
const reportingApi = {
  getPublisherIdsWithStats(payload) {
    return client.get(`/stats/publishers?creativeIds=${payload.creativeIds}`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  getPublisherStats(payload) {
    return client.get(`/stats/a/${payload.advertiserId}/campaigns/${payload.campaignId}/stats/publisher`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  getPublisherDailyStats(payload) {
    if (payload.creativeIds) {
      return client.get(`/stats/a/${payload.advertiserId}/campaigns/${payload.campaignId}/stats/publisher-daily?fromDate=${payload.startDate}&toDate=${payload.endDate}&publisherIds=${payload.publisherIds}&creativeIds=${payload.creativeIds}`)
        .then((response) => response.data)
        .catch((error) => {
          throw error;
        });
    }

    return client.get(`/stats/a/${payload.advertiserId}/campaigns/${payload.campaignId}/stats/publisher-daily?fromDate=${payload.startDate}&toDate=${payload.endDate}&publisherIds=${payload.publisherIds}`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  downloadDailyReportCSV(payload) {
    return client.get(`/stats/a/${payload.advertiserId}/campaigns/${payload.campaignId}/stats/publisher-daily-csv?fromDate=${payload.startDate}&toDate=${payload.endDate}&publisherIds=${payload.publisherIds}&creativeIds=${payload.creativeIds}&reportType=${payload.reportType}`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  getContentDailyStats(payload) {
    return client.get(`/stats/a/${payload.advertiserId}/campaigns/${payload.campaignId}/stats/advertiser-content?fromDate=${payload.startDate}&toDate=${payload.endDate}&publisherIds=${payload.publisherIds}&creativeIds=${payload.creativeIds}`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  getOverallCreativeCampaignStats(payload) {
    return client.get(`/stats/a/${payload.advertiserId}/campaigns/${payload.campaignId}/creatives/stats?fromDate=${payload.startDate}&toDate=${payload.endDate}&publisherIds=${payload.publisherIds}&creativeIds=${payload.creativeIds}`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  downloadContentReportCSV(payload) {
    return client.get(`/stats/a/${payload.advertiserId}/campaigns/${payload.campaignId}/stats/advertiser-content-csv?fromDate=${payload.startDate}&toDate=${payload.endDate}&publisherIds=${payload.publisherIds}&creativeIds=${payload.creativeIds}&reportType=${payload.reportType}`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  getCampaignDeliveryStats(payload) {
    return client.get(`/stats/a/${payload.advertiserId}/campaigns/${payload.campaignId}/stats/advertiser-daily`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  downloadCreativeReportCSV(payload) {
    return client.get(`/stats/a/${payload.advertiserId}/campaigns/${payload.campaignId}/creatives/stats/csv?fromDate=${payload.startDate}&toDate=${payload.endDate}&publisherIds=${payload.publisherIds}&creativeIds=${payload.creativeIds}&reportType=${payload.reportType}`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  downloadReportAsCSV(payload) {
    return client.post('/stats/generate/csv-report', payload)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  // STATEMENTS
  getReportStatementsForType(payload) {
    return client.get(`/stats/campaigns/${payload.campaignId}/statements?type=${payload.type}`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  putReportStatementsForType(payload) {
    return client.put(`/stats/campaigns/${payload.campaignId}/statements`, payload.body)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  getCampaignReportConfiguration(payload) {
    return client.get(`/stats/campaigns/${payload.campaignId}/report-configuration`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  patchCampaignReportConfiguration(payload) {
    return client.patch(`/stats/campaigns/${payload.campaignId}/report-configuration`, payload.body)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  publishCampaignReportStatements(payload) {
    return client.post(`/stats/campaigns/${payload.campaignId}/statements/publish`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  patchSummaryEnabledStatements(payload) {
    return client.patch(`/stats/campaigns/${payload.campaignId}/statements`, payload.body)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
};
export default reportingApi;
